// Update images array in DB
export const updateImagesByView = async ({ uuid, imageId, view, token }) => {
	try {
		const api = await fetch('/api/update-images', {
			method: 'POST',
			headers: { Authorization: `Bearer ${token}` },
			body: JSON.stringify({
				uuid,
				imageId,
				view,
			}),
		})

		if (!api.ok) {
			console.error('Failed to set primary image:', api.error)
			return
		}
		const response = await api.json()

		return response
	} catch (err) {
		console.error('Error setting primary image:', err)
	}
}

// S3 functions via APIV3
export const getFileByUUID = async (endpoint, index) => {
	try {
		const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/${endpoint}?index=${index}&output=url`

		const response = await fetch(url, {
			headers: {
				'x-api-key': process.env.VUE_APP_AWS_API_KEY,
			},
		})

		if (!response.ok) {
			throw new Error(
				`Failed to fetch file: ${response.status} ${response.statusText}`,
			)
		}

		const data = await response.json()
		return data.url
	} catch (err) {
		console.error('An error occurred while fetching the file:', err)
		throw err
	}
}

export const uploadFile = async (uuid, file, type, source = 'manual') => {
	try {
		const apiURL = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/${uuid}/files`

		const formData = new FormData()
		formData.append('file', file)
		formData.append('type', type)
		formData.append('source', source)

		const api = await fetch(apiURL, {
			method: 'PUT',
			headers: {
				'x-api-key': process.env.VUE_APP_AWS_API_KEY,
			},
			body: formData,
		})

		if (!api.ok) {
			throw new Error(`Upload failed: ${api.status} ${api.statusText}`)
		}

		const response = await api.json()

		const { images } = response.data
		return { images }
	} catch (err) {
		console.error('An error occurred while uploading the file:', err)
		throw err
	}
}

export const deleteFile = async (uuid, viewType, index) => {
	try {
		const apiURL = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/${uuid}/files`

		const bodyData = { viewType, index }

		const api = await fetch(apiURL, {
			method: 'DELETE',
			headers: {
				'x-api-key': process.env.VUE_APP_AWS_API_KEY,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(bodyData),
		})

		if (!api.ok) {
			throw new Error(`Could not delete file: ${api.status} ${api.statusText}`)
		}

		const response = await api.json()

		return response
	} catch (err) {
		console.error('An error occurred while deleting the file:', err)
		throw err
	}
}

export const getFilesFromCyclomedia = async (
	view,
	coords,
	code,
	country = 'nl',
) => {
	try {
		const apiUrl = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/files/cyclomedia`

		const payload = { view, coords, code, country }

		const response = await fetch(apiUrl, {
			method: 'POST',
			headers: {
				'x-api-key': process.env.VUE_APP_AWS_API_KEY,
			},
			body: JSON.stringify(payload),
		})

		if (!response.ok) {
			throw new Error(
				`Failed to fetch files: ${response.status} ${response.statusText}`,
			)
		}

		const base64DataArray = await response.json()

		return base64DataArray.map((base64Data, index) => {
			const blob = Buffer.from(base64Data, 'base64')
			const file = new File([blob], `cyclomedia-${view}-${index}.jpg`, { type: 'image/jpg' })

			return file
		})

	} catch (error) {
		console.log('Could not create location', error)
	}
}
